// Reports uncaught browser errors to the admin System Monitor
// (POST /api/monitoring/client-errors). Uses raw fetch instead of the api
// client so a failed/401 report can never trigger the global logout redirect.

const MAX_REPORTS_PER_SESSION = 20;
const DEDUPE_WINDOW_MS = 30_000;

let sent = 0;
const recent = new Map(); // message -> last sent ts
let installed = false;

function report(message, stack) {
  const token = localStorage.getItem('token');
  if (!token || !message || sent >= MAX_REPORTS_PER_SESSION) return;

  const last = recent.get(message);
  if (last && Date.now() - last < DEDUPE_WINDOW_MS) return;
  recent.set(message, Date.now());
  sent += 1;

  fetch('/api/monitoring/client-errors', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      message: String(message).slice(0, 2000),
      stack: stack ? String(stack).slice(0, 8000) : undefined,
      url: window.location.href,
      user_agent: navigator.userAgent,
    }),
  }).catch(() => {}); // reporting must never throw
}

export function initErrorReporter() {
  if (installed) return;
  installed = true;

  window.addEventListener('error', e => {
    report(e.message || 'Script error', e.error?.stack);
  });

  window.addEventListener('unhandledrejection', e => {
    const r = e.reason;
    report(`Unhandled rejection: ${r?.message || r}`, r?.stack);
  });
}
